// eslint-disable-next-line import/prefer-default-export
export const MAIN_INFO_SCHEMA = {
  bankName: {
    label: 'Bank name',
    isRequired: true,
    type: 'text',
    default: null,
  },
  iban: {
    label: 'Your IBAN/Account Number',
    isRequired: true,
    default: null,
    type: 'text',
  },
  bankAddress: {
    label: 'Bank Address',
    isRequired: true,
    default: null,
    type: 'text',
  },
  sendingWithTransferwise: {
    label: 'Are you sending with Wise?',
    isRequired: false,
    default: null,
    type: 'checkbox',
    subItem: {
      bankNameTransferwise: {
        label: 'Bank Name Wise',
        isRequired: false,
        default: null,
        type: 'text',
      },
      bankAddressTransferwise: {
        label: 'Bank Address Wise',
        isRequired: false,
        default: null,
        type: 'text',
      },
      memberShipNumberTransferwise: {
        label: 'Wise Membership number',
        isRequired: false,
        default: null,
        type: 'text',
      },
    },
  },
}
